export function sortParamFormatter(sortField, sortOrder) {
    if (sortField && sortOrder) {
        return `${sortField}.${sortOrder}`;
    }
    return undefined;
}
//# sourceMappingURL=sort_params.js.map